import {ref} from 'vue';

export default {
    install: (app, options) => {
        const broadcastListened = ref(false);
        const broadcastCompanyListened = ref(false);

        app.provide('broadcastListened', broadcastListened);
        app.provide('broadcastCompanyListened', broadcastCompanyListened);
    },
}
